const getInputWidth = (value) => {
  const length = Math.max(value.length, 1);
  const approxCharWidth = 15;
  const width = length * approxCharWidth;
  return Math.min(width, window.innerWidth * 0.8);
};
export {
  getInputWidth
};